export const USER_EMAIL = 'user-email';
export const USER_SESSION_DATA = 'user-session-data';
export const LANGUAGE = 'language';
export const AVAILABLE_COUNTRY = 'available-country'; 
export const ALL_COUNTRY = 'all-country'
export const AF_USER_SESSION_DATA = 'aff-user-session-data'
export const AFID = 'afid';
export const languageList = ['en','es','pt']
export const AVAILABLE_BUNDLES = 'available-bundles'
